import { useEffect } from "react";
import { DOCUMENT_TITLE } from "store/slices/appSlice";
import { useAppDispatch } from "store/store";

const useDocumentTitle = (title: string, description?: string) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    document.title = `GridKey | ${title}`;
    dispatch(DOCUMENT_TITLE(title));

    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        (metaDesc as HTMLMetaElement).name = "description";
        document.head.appendChild(metaDesc);
      }
      (metaDesc as HTMLMetaElement).content = description;
    }
  }, [title, description]);
};

export default useDocumentTitle;
